"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _classnames = _interopRequireDefault(require("classnames"));

var _field = require("../../utils/field");

var _FormContext = require("../../context/FormContext");

var _attrs = require("../../utils/attrs");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  "formWrapper": "index__formWrapper",
  "formBtn": "index__formBtn",
  "formBtnCancel": "index__formBtnCancel",
  "formLink": "index__formLink",
  "withoutOpd": "index__withoutOpd",
  "formLabel": "index__formLabel",
  "formLabelRequired": "index__formLabelRequired",
  "formLabelOptional": "index__formLabelOptional",
  "formInput": "index__formInput",
  "formTextarea": "index__formTextarea",
  "formSection": "index__formSection",
  "formSectionRow": "index__formSectionRow",
  "formSectionBtn": "index__formSectionBtn",
  "error": "index__error",
  "compositeError": "index__compositeError",
  "fileInput": "index__fileInput",
  "fileControls": "index__fileControls",
  "formDateSelect": "index__formDateSelect",
  "formMoneySelect": "index__formMoneySelect",
  "amountField": "index__amountField",
  "currencyField": "index__currencyField",
  "imagePreview": "index__imagePreview",
  "dangerBtn": "index__dangerBtn",
  "dangerBtnDisabled": "index__dangerBtnDisabled",
  "fileList": "index__fileList",
  "fileItem": "index__fileItem",
  "downloadButton": "index__downloadButton",
  "downloadButtonDisabled": "index__downloadButtonDisabled",
  "fileButtonGroup": "index__fileButtonGroup",
  "timeIndicator": "index__timeIndicator",
  "modalButtonGroup": "index__modalButtonGroup"
};

var _default = function _default(WrappedComponent) {
  var _temp;

  return _temp = /*#__PURE__*/function (_Component) {
    (0, _inherits2["default"])(FieldWrapper, _Component);

    var _super = _createSuper(FieldWrapper);

    function FieldWrapper(props) {
      var _this;

      (0, _classCallCheck2["default"])(this, FieldWrapper);
      _this = _super.call(this, props);
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggleRequired", function (required) {
        var _this$props = _this.props,
            initialRequired = _this$props.initialRequired,
            settings = _this$props.settings;
        var isLinked = (0, _field.isLinkedField)({
          settings: settings
        });
        !isLinked && initialRequired && _this.setState({
          required: required ? initialRequired || required : false
        });
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (value) {
        var _this$props2 = _this.props,
            onChange = _this$props2.onChange,
            onChangeQuestion = _this$props2.onChangeQuestion,
            field = _this$props2.field,
            form = _this$props2.form,
            resetFieldState = _this$props2.form.resetFieldState,
            _this$props2$meta = _this$props2.meta,
            modified = _this$props2$meta.modified,
            submitting = _this$props2$meta.submitting;

        var serverError = _this.getServerError();

        if (!submitting) {
          _this.props.input.onChange(value);

          onChange && onChange(value, form);
          onChangeQuestion && onChangeQuestion(value, form);
        }

        if (serverError && modified) {
          resetFieldState(field);
        }
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "hideLabel", function () {
        var _this$props3 = _this.props,
            fieldType = _this$props3.fieldType,
            label = _this$props3.label;
        var HIDE_TYPES = ['boolean', 'personalDataAgreement'];
        return (0, _ramda.contains)(fieldType, HIDE_TYPES) || !label;
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getServerError", function () {
        var _this$props4 = _this.props,
            name = _this$props4.input.name,
            serverErrors = _this$props4.serverErrors;
        var gqlErrors = (0, _ramda.prop)('graphQLErrors', serverErrors);

        if (!serverErrors) {
          return undefined;
        }

        var errors = Array.isArray(serverErrors) ? serverErrors : (0, _ramda.path)(['data', 'errors'], serverErrors);

        if (gqlErrors) {
          var validationErrors = (0, _ramda.find)((0, _ramda.propEq)('message', 'Validation failed'), gqlErrors);

          var _errors = (0, _ramda.propOr)({}, 'errors', validationErrors);

          return (0, _ramda.path)([name, 0, 'message'], _errors);
        }

        if (Array.isArray(errors)) {
          var fieldErrorObj = (0, _ramda.find)((0, _ramda.propEq)('field', name), errors);
          return (0, _ramda.prop)('message', fieldErrorObj);
        }
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setInputError", function (errorFromInput) {
        return _this.setState({
          errorFromInput: errorFromInput
        });
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderError", function () {
        var _this$props$meta = _this.props.meta,
            error = _this$props$meta.error,
            submitFailed = _this$props$meta.submitFailed,
            modifiedSinceLastSubmit = _this$props$meta.modifiedSinceLastSubmit,
            dirtySinceLastSubmit = _this$props$meta.dirtySinceLastSubmit;
        var errorFromInput = _this.state.errorFromInput;

        var serverError = _this.getServerError();

        var showServerError = !modifiedSinceLastSubmit && !dirtySinceLastSubmit && serverError;

        if (errorFromInput) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: styles.error
          }, "".concat(errorFromInput));
        } else if (showServerError) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: styles.error
          }, "".concat(serverError));
        } else {
          return submitFailed && error ? /*#__PURE__*/_react["default"].createElement("div", {
            className: styles.error
          }, "".concat((0, _ramda.is)(Object, error) ? (0, _ramda.join)('', (0, _ramda.values)(error)) : error)) : null;
        }
      });
      _this.state = {
        required: _this.props.required,
        errorFromInput: undefined
      };
      return _this;
    }

    (0, _createClass2["default"])(FieldWrapper, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props5 = this.props,
            label = _this$props5.label,
            _this$props5$extra = _this$props5.extra,
            extra = _this$props5$extra === void 0 ? '' : _this$props5$extra,
            _this$props5$meta = _this$props5.meta,
            error = _this$props5$meta.error,
            modifiedSinceLastSubmit = _this$props5$meta.modifiedSinceLastSubmit,
            dirtySinceLastSubmit = _this$props5$meta.dirtySinceLastSubmit,
            settings = _this$props5.settings,
            name = _this$props5.input.name,
            fieldHtmlAttrs = _this$props5.htmlAttrs,
            fieldType = _this$props5.fieldType;
        var serverError = this.getServerError();
        var isLinked = (0, _field.isLinkedField)({
          settings: settings
        });
        var required = isLinked ? this.props.required : this.state.required;
        var showServerError = !modifiedSinceLastSubmit && !dirtySinceLastSubmit && serverError;
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginBottom: 20
          },
          className: (0, _classnames["default"])("jobot-form-field-".concat(fieldType), {
            'jobot-form-invalid': !!error || showServerError,
            'jobot-form-field-textarea': !!(0, _ramda.path)(['textarea'], settings)
          })
        }, !this.hideLabel() && /*#__PURE__*/_react["default"].createElement("label", {
          className: required ? styles.formLabelRequired : styles.formLabel
        }, label, extra), /*#__PURE__*/_react["default"].createElement("div", {
          id: "field-".concat(name)
        }, /*#__PURE__*/_react["default"].createElement(_FormContext.FormContext.Consumer, null, function (_ref) {
          var disabled = _ref.disabled,
              htmlAttrs = _ref.htmlAttrs;
          return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, _this2.props, {
            disabled: disabled,
            onChange: _this2.onChange,
            toggleRequired: _this2.toggleRequired,
            required: required,
            setInputError: _this2.setInputError,
            htmlAttrs: fieldHtmlAttrs || (0, _attrs.getAttrs)(name, htmlAttrs)
          }));
        })), this.renderError());
      }
    }]);
    return FieldWrapper;
  }(_react.Component), _temp;
};

exports["default"] = _default;